import { useMemo, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { StandardButton } from "../../../components/buttons/StandardButton"
import { InstructionDialog } from "../../../components/dialogs/instructionDialog/InstructionDialog"
import { useAppSelector } from "../../../../modules/store/storeHooks"
import { selectEffectiveCompanyId, selectEffectiveUserType } from "../../../../modules/context/contextSelectors"
import { UserType } from "../../../../modules/login/loginTypes"
import { useApiQuery } from "../../../../core/api/useApiQuery"
import { fetchInstructionsByRole, InstructionsResponse, SupportInstructionsQuery, UserTypeURL } from "./instructionApi"
import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"

const useStyles = makeStyles()(() => ({
    button: {
        backgroundColor: "#FDEDED",
        color: "#5F2120",
        height: "fit-content",
        "&:hover": {
            backgroundColor: "#FDEDED",
        },
    },
}))

const transformData = (data: InstructionsResponse) => {
    return data.instructions
}

export function InstructionButton() {
    const { classes } = useStyles()
    const [dialogState, setDialogState] = useState(false)

    const currentUserType = useAppSelector(selectEffectiveUserType)
    const currentUserId = useAppSelector(selectEffectiveCompanyId)

    const instructionConfig = useMemo(() => {
        switch (currentUserType) {
            case UserType.SUPPLIER:
                return {
                    queryName: SupportInstructionsQuery.INSTRUCTIONS_FOR_SUPPLIER,
                    role: UserTypeURL.SUPPLIER,
                }
            case UserType.COMPANY:
                return {
                    queryName: SupportInstructionsQuery.INSTRUCTIONS_FOR_COMPANY,
                    role: UserTypeURL.COMPANY,
                }
            case UserType.MERCHANT:
                return {
                    queryName: SupportInstructionsQuery.INSTRUCTIONS_FOR_MERCHANT,
                    role: UserTypeURL.MERCHANT,
                }
            default:
                return {
                    queryName: "",
                    role: UserTypeURL.DEFAULT,
                }
        }
    }, [currentUserType])

    const { data: instructions } = useApiQuery(fetchInstructionsByRole, {
        queryName: instructionConfig.queryName,
        dependencies: {
            userId: currentUserId ?? 0,
            role: instructionConfig.role,
        },
        enabled:
            (Boolean(currentUserId) && currentUserType === UserType.COMPANY) ||
            currentUserType === UserType.MERCHANT ||
            currentUserType === UserType.SUPPLIER,
        select: transformData,
    })

    if (!instructions || instructions.length === 0) {
        return null
    }

    return (
        <>
            <LocalizedStrict id="support-instructions-dialog-title">
                <StandardButton
                    fullWidth={false}
                    className={classes.button}
                    size="small"
                    onClick={() => setDialogState((prev) => !prev)}
                >
                    Instructions
                </StandardButton>
            </LocalizedStrict>
            <InstructionDialog instructions={instructions} dialogState={dialogState} setDialogState={setDialogState} />
        </>
    )
}
